// extracted by mini-css-extract-plugin
module.exports = {"ingredientsContainer":"RecipeIngredients_ingredientsContainer__9k0zc","ingredientsInnerContainer":"RecipeIngredients_ingredientsInnerContainer__xZN7D"};